module.exports = __webpack_public_path__ + "img/medida.37cdcb27.jpeg";